module.exports = __webpack_public_path__ + "static/img/logo.ad6b2ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 21